const site_data = {
  title: 'Engineering Book Club',
  description: 'The Engineering Book Club is an online community for professionals that wants to read books together.',
  keyword: 'engineering, book, club, community, engineers',
  twitter: '@TheEngBookClub',
  email: 'hello@engineeringbookclub.com',
}

export {site_data};
